import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import './LiveGameStatsTicker.css';

const DEFAULT_ITEMS = [
  '200+ Played RapHousie today',
  '26.5 M RapCoins Credited to Player',
  '200 Playing in Corporate Room',
];

/**
 * Figma 18115:3669 — yellow gradient live-stats marquee ticker.
 * Place at the bottom under the 3 gameplay columns.
 */
const LiveGameStatsTicker = ({ items = DEFAULT_ITEMS, className = '' }) => {
  const sequence = items.length > 0 ? items : DEFAULT_ITEMS;
  // Duplicate for seamless loop; trailing dot after every item keeps the seam clean
  const loopItems = [...sequence, ...sequence];

  return (
    <div
      className={`live-stats-ticker${className ? ` ${className}` : ''}`}
      data-node-id="18115:3669"
      aria-label="Live game stats"
    >
      <div className="live-stats-ticker__viewport">
        <div className="live-stats-ticker__track">
          {loopItems.map((text, index) => (
            <React.Fragment key={`${text}-${index}`}>
              <span className="live-stats-ticker__text">{text}</span>
              <img
                className="live-stats-ticker__dot"
                src={IMAGE_CONSTANTS.V2_LIVE_TICKER_DOT}
                alt=""
                width={17}
                height={17}
                aria-hidden="true"
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

LiveGameStatsTicker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

export default LiveGameStatsTicker;
